import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../../helpers/BreadcrumbsHelper';
import { SelectComponentV2 } from '../../components/SelectComponentV2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AppTheme } from '../../styles/AppTheme';
import { SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS } from 'constants';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import { TextInputComponent } from '../../components/TextInputComponent';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../../AppConfig';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import { StatCard } from '../../common/components/StatCard';
import Grid from '@material-ui/core/Grid';
import { ApiHelper } from '../../common/helpers/ApiHelper';

export class EventStats extends Component {
  constructor(props) {
    super(props);
    this.statFields = {
      parkedVal: {
        key: 'parkedVal',
        label: 'PARKED',
        type: 'text'
      }
    },
    this.state = {
      statUpdateInProcess: false,
    }
  }

  isValidStatField = () => {
    //const SCORE_REGEXP = /^\d?$/i;
    const SCORE_REGEXP = /^\d+$/i;

    if (!SCORE_REGEXP.test(this.props.parkedVal)) {
      const formFieldErrMsg = this.state.formFieldErrMsg;
      this.setState({
        statFieldErrMsg: 'Not a valid number'
      })
      return false
    }
    return true
  }

  change = e => {
    this.props.parkedValChangeHandler(e.target.value)
  }

  submitStat = () => {

    const newStatAdjust = Number(this.props.parkedVal) - (this.props.parkingEntryTotal.IN_TOTAL - this.props.parkingEntryTotal.OUT_TOTAL)

    this.setState({
      statUpdateInProcess: true
    })

    if (!this.isValidStatField()) {
      this.setState({
        statFieldErrMsg: 'Not a valid number',
        statUpdateInProcess: false,
      })
      return
    }

    const payload = {
      placeData: {
        statAdjust: newStatAdjust
      }
    }
    const options = {
      method: 'PUT',
      endPoint: ApiHelper.makeUrlPath(['places', this.props.place._id]),
      jsonBody: payload
    }

    console.log('options', options)
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          statFieldErrMsg: msg,
          statUpdateInProcess: false,
        })
        return
      }

      this.setState({
        statUpdateInProcess: false,
        statFieldErrMsg: null
      })
      this.props.statUpdateHandler(newStatAdjust)
      this.props.closeStatDialog()
    }.bind(this))
  }

  renderStatDialog() {
    const statField = this.statFields.parkedVal;
    //this.parkedVal = this.props.parkingEntry.PARKED;

    return (
      <Dialog
        onClose={this.props.closeStatDialog}
        open={this.props.statDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <div className={css(Styles.dialogTitleContainer)}>
            <p className={css(Styles.dialogTitleContent)}>Set value of PARKED</p>

            <div className={css(Styles.closeIconContainer)} onClick={this.props.closeStatDialog}>
              <img src={require('../../assets/images/close-img.svg')} className={css(Styles.closeIcon)} />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            <div className={css(Styles.statAdjustInfo)}>
              <p className={css(Styles.statAdjustContainerTitle)}>IN (Total)</p>
              <p className={css(Styles.statAdjustVal)}>{this.props.parkingEntryTotal.IN_TOTAL}</p>
            </div>

            <div className={css(Styles.statAdjustInfo)}>
              <p className={css(Styles.statAdjustContainerTitle)}>OUT (Total)</p>
              <p className={css(Styles.statAdjustVal)}>{this.props.parkingEntryTotal.OUT_TOTAL}</p>
            </div>

            <div className={css(Styles.statAdjustInfo)}>
              <p className={css(Styles.statAdjustContainerTitle)}>Stat correction</p>
              <p className={css(Styles.statAdjustVal)}>{this.props.statAdjust}</p>
            </div>

            <div>
              <TextField
                id={statField.key}
                label={statField.label}
                name={statField.key}
                className={css(Styles.inputCssText)}
                value={this.props.parkedVal}
                onChange={e => this.change(e)}
                margin='normal'
                type={statField.type}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: css(Styles.textFieldContentInput, Styles.textFieldContentInputText),
                  }
                }}
                InputLabelProps={{
                  classes: {
                    root: css(Styles.textFieldContent),
                  }
                }}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            variant='contained'
            onClick={e => this.submitStat()}
            className={css(Styles.actionButton)}>
            Submit
          </Button>
          <Button
            variant='contained'
            onClick={() => this.props.closeStatDialog()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.statFieldErrMsg &&
          <p className={css(Styles.errMsg)}>{this.state.statFieldErrMsg}</p>
        }
      </Dialog>
    );
  }

  getCardFooter = (k) => {
    if (k === 'PARKED') {
      return (
        <div className={css(Styles.statAdjustContainer)}>
          <div style={{ flex: 1 }}></div>
          <Fab
            color='primary'
            classes={{
              root: css(Styles.statAdjustIconContainer),
            }}
            aria-label='delete'
            size={'small'}
            onClick={() => this.props.openStatDialog()}>
            <Icon className={css(Styles.statAdjustIcon)}>edit</Icon>
          </Fab>
        </div>
      )
    } else {
      return null
    }
  }

  render = () => {
    if (this.props.eventLatest &&
      this.props.eventLatest.stat &&
      this.props.place &&
      this.props.place.type !== 'parking_in_out' &&
      Object.keys(this.props.eventLatest.stat).length > 0) {
      return (
        <div className={css(Styles.outerHeaderStatCard)}>
          <div className={css(Styles.statContainer)}>
            <div className={css(Styles.statContainerTitle)}>
              <div className={css(Styles.statTitleImg)}>
                <img src={require('../../assets/images/summaryIcon.svg')} className={css(Styles.eventImage)} />
              </div>
              <p className={css(Styles.statTitle)}>Summary</p>
            </div>
            <Grid container spacing={2} >
              {Object.keys(this.props.eventLatest.stat).map((k, index) => (
                <StatCard
                  key={k}
                  text={k}
                  subText={this.props.eventLatest.stat[k]}
                  cardIndex={index}
                />
              ))}
            </Grid>
          </div>
          {this.props.statDialog &&
            this.renderStatDialog()
          }
        </div>
      )
    }


    if (this.props.place &&
      this.props.place.type === 'parking_in_out') {
      return (
        <div className={css(Styles.outerHeaderStatCard)}>
          <div className={css(Styles.statContainer)}>
            <div className={css(Styles.statContainerTitle)}>
              <div className={css(Styles.statTitleImg)}>
                <img src={require('../../assets/images/summaryIcon.svg')} className={css(Styles.eventImage)} />
              </div>
              <p className={css(Styles.statTitle)}>Summary</p>
            </div>
            <Grid container spacing={2} >
              {Object.keys(this.props.parkingEntry).map((k, index) => (
                <StatCard
                  key={k}
                  text={k}
                  subText={this.props.parkingEntry[k]}
                  cardIndex={index}
                  cardFooter={() => this.getCardFooter(k)}
                />
              ))}
            </Grid>
          </div>
          {this.props.statDialog &&
            this.renderStatDialog()
          }
        </div>
      )
    }

    return ''
  }
}


// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventStats.js